(function (w) {
  function stripZeroDecimals(formatted) {
    if (formatted == null) return formatted;
    return String(formatted).replace(/([.,])00(?!\d)/g, '');
  }

  function formatMoneyFromCents(cents) {
    var amount = Math.round(Number(cents || 0));
    var whole = Math.floor(Math.abs(amount) / 100);
    var rem = Math.abs(amount) % 100;
    var sign = amount < 0 ? '-' : '';
    if (rem === 0) return sign + '$' + whole;
    return sign + '$' + whole + ',' + String(rem).padStart(2, '0');
  }

  w.rnStripZeroDecimals = stripZeroDecimals;
  w.rnFormatMoney = formatMoneyFromCents;

  function patchShopifyFormatMoney() {
    if (!w.Shopify || typeof w.Shopify.formatMoney !== 'function' || w.Shopify.formatMoney.__rnPatched) {
      return;
    }
    var original = w.Shopify.formatMoney.bind(w.Shopify);
    w.Shopify.formatMoney = function (cents, format) {
      return stripZeroDecimals(original(cents, format));
    };
    w.Shopify.formatMoney.__rnPatched = true;
  }

  patchShopifyFormatMoney();
  if (w.document) {
    w.document.addEventListener('DOMContentLoaded', patchShopifyFormatMoney);
  }
})(window);
